/**************************************************************************************************/
/*   File: /src/app/app.component.ts                                                              */
/*   Project: newplan-frontend                                                                    */
/*   Created Date: Friday February 22nd 2019                                                      */
/*   Author: Andrea Zamboni andrea.zamboni@trilogis.it                                            */
/*   -----                                                                                        */
/*   Last Modified: Thu May 30 2019                                                               */
/*   Modified By: Andrea Zamboni                                                                  */
/*   -----                                                                                        */
/*   Copyright (c) 2019 Trilogis s.r.l. for SIAG                                                  */
/**************************************************************************************************/
import { NGXLogger } from 'ngx-logger';
import { Observable, Subscription } from 'rxjs';

import { AfterViewInit, Component, OnInit, OnDestroy } from '@angular/core';
import { select, Store } from '@ngrx/store';

import * as fromSelectors from './stores/selectors';
import * as fromStates from './stores/states';

/**
 * The application component
 */
@Component({
  selector: 'nwpl-frnt-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, AfterViewInit, OnDestroy {

  /**
   * The is loading flag;
   */
  isLoading$: Observable<boolean>;
  /**
   * The array of subscription
   */
  private subscriptions: Subscription[] = [];


  /**
   * The constructor
   * @param logger The logger
   */
  constructor(private logger: NGXLogger, private store: Store<fromStates.fromRoot.RootState>) {
    this.logger.debug('Contruct the app component');
  }

  /**
   * The on init hook
   */
  ngOnInit() {
    this.isLoading$ = this.store.pipe(
      select(fromSelectors.fromRoot.getIsLoading)
    );
  }

  /**
   * The ng on after view init hook
   */
  /* istanbul ignore next */
  ngAfterViewInit(): void {

    setTimeout(() => {
      this.isLoading$ = this.store.pipe(
        select(fromSelectors.fromRoot.getIsLoading)
      );
    }, 0);
  }

  /**
   * The ng on destroy hook
   */
  /* istanbul ignore next */
  ngOnDestroy(): void {
    /* this.logger.trace('Remove subscriptions AppComponent'); */
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
  }

}

